import {DialogTypes} from '../types/DialogTypes';
import {PromoPhotosFormType} from '../types/PromoPhotosFormType';
import {PromoPhotosType} from '../types/PromoPhotosType';
import {getPromoPhotoRequestData} from './getPromoPhotoRequestData';

// A changed composition re-renders the financing cards, so it counts as a photo change.
export const getDialogTypeByValues = (editData: PromoPhotosType, data: PromoPhotosFormType) => {
  const request = getPromoPhotoRequestData(data);
  const isPhotoChanged =
    editData.fileId !== request.fileId ||
    JSON.stringify(editData.composition) !== JSON.stringify(request.composition);
  const isOrderChanged = editData.position !== request.position;

  if (isPhotoChanged && isOrderChanged) {
    return DialogTypes.ORDER_PHOTO_CHANGE;
  }

  if (isPhotoChanged) {
    return DialogTypes.PHOTO_CHANGE;
  }

  if (isOrderChanged) {
    return DialogTypes.ORDER_CHANGE;
  }
};
